$(document).ready(function(){
  $(document).on('click', '[data-behaviour~=show-video]', function (e) {
    $this = $(this);
    $autoplay = $this.data('autoplay');
    $video_id = $this.data('video');
    if ($video_id){
      e.preventDefault();
      var $width = 560;
      var $height = 315;
      if ($this.data('width')){ $width = parseInt($this.data('width')); }
      if ($this.data('height')){ $height =  parseInt($this.data('height')); }
      var $iframe = '<iframe width="' + $width + '" height="'+ $height +'" scrolling="no" allowtransparency="true" allowfullscreen="true" src="https://www.youtube.com/embed/'+ $video_id +'?rel=0&wmode=transparent&showinfo=0&autoplay=' + $autoplay + '" frameborder="0"></iframe>';
      $('#mediaModal .modal-body').html($iframe);
      $('#mediaModal').modal();
    }
  });

  $('#mediaModal').on('hidden.bs.modal', function () {
    $('#mediaModal .modal-body').html('');
  });

}); 
